function bitmapToCoverageCount(bitmap) {
  const counts = bitmap.reduce(
    (acc, identity) => {
      acc[identity] ??= 0;
      acc[identity]++;
      return acc;
    },
    { total: bitmap.length }
  );
  return counts;
}
export {
  bitmapToCoverageCount
};
//# sourceMappingURL=bitmapToCoverageCount.js.map
